<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">Nasiyalar (Qarzlar)</h2>
        <div class="header-actions">
          <!-- Ko'rinish: Qarzdor / Haqdor / Hammasi -->
          <div class="view-tabs">
            <button :class="['vt-btn', viewMode==='debtor'   ? 'active debtor' : '']" @click="setViewMode('debtor')">📕 Qarzdorlar</button>
            <button :class="['vt-btn', viewMode==='creditor' ? 'active creditor' : '']" @click="setViewMode('creditor')">📗 Haqdorlar</button>
            <button :class="['vt-btn', viewMode==='all'      ? 'active' : '']" @click="setViewMode('all')">Hammasi</button>
          </div>
          <div class="filter-tabs">
            <button
              v-for="f in filterOptions"
              :key="f.value"
              :class="['ft-btn', filterStatus === f.value ? 'active' : '']"
              @click="filterStatus = f.value"
            >
              {{ f.label }}
              <span v-if="filterCounts[f.value] > 0" class="ft-badge">{{ filterCounts[f.value] }}</span>
            </button>
          </div>
          <!-- Eslatma oynasi (kun): muddati o'tgan/yaqinlashayotganlarni shu kun bo'yicha hisoblaydi -->
          <div class="alert-days">
            <span class="ad-label">Eslatma:</span>
            <button class="ad-step" type="button" @click="alertDays = Math.max(1, Number(alertDays) - 1)">−</button>
            <input
              type="number" min="1" max="365"
              v-model.number="alertDays"
              class="ad-input"
              title="Necha kun ichida muddati o'tgan/yaqinlashayotganlarni ko'rsatish"
            />
            <button class="ad-step" type="button" @click="alertDays = Math.min(365, Number(alertDays) + 1)">+</button>
            <span class="ad-suffix">kun</span>
          </div>
          <div class="search-box">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="searchText" type="text" placeholder="Mijoz qidirish..." class="search-input" />
          </div>
          <div class="total-badge" :class="viewMode==='creditor' ? 'creditor' : ''">
            {{ viewMode==='creditor' ? 'Biz qarzmiz' : (viewMode==='all' ? 'Jami (qarz+haqdor)' : 'Jami qarz') }}:
            <b v-if="totalDebt > 0 || totalDebtDollar === 0">{{ formatMoney(totalDebt) }} UZS</b>
            <span v-if="totalDebt > 0 && totalDebtDollar > 0"> / </span>
            <b v-if="totalDebtDollar > 0">{{ formatDollar(totalDebtDollar) }} $</b>
          </div>
          <Top />
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:55px">№</th>
                <th>MIJOZ NOMI</th>
                <th>TELEFON</th>
                <th>MANZIL</th>
                <th>TO'LOV SANASI</th>
                <th>SO'M QARZI</th>
                <th>DOLLAR QARZI</th>
                <th style="width:120px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredDebtors" :key="item.id" class="debt-row clickable-row" :class="rowOnlyCreditor(item) ? 'is-creditor' : ''" @click="openDebtorSales(item)">
                <td><span class="id-badge" :class="rowOnlyCreditor(item) ? 'cr' : ''">{{ index + 1 }}</span></td>

                <td>
                  <div class="font-bold text-dark">
                    {{ item.name }}
                    <span v-if="rowOnlyCreditor(item)" class="cr-tag">Biz qarzmiz</span>
                  </div>
                </td>

                <td>
                  <span class="phone-tag">{{ item.phone_number || '-' }}</span>
                </td>

                <td>
                  <span class="text-muted small">{{ item.address || '-' }}</span>
                </td>

                <td>
                  <span v-if="item.payment_date" :class="dueDateTagClass(item)">
                    {{ formatPaymentDate(item.payment_date) }}
                    <span v-if="debtStatus(item) === 'overdue' || debtStatus(item) === 'overdue_old'"> (Muddati o'tgan)</span>
                    <span v-else-if="debtStatus(item) === 'upcoming'"> (Yaqinlashyapti)</span>
                  </span>
                  <span v-else class="text-muted small">-</span>
                </td>

                <td>
                  <div v-if="item.debt > 0" class="debt-amount">
                    {{ formatMoney(item.debt) }} <span class="currency">UZS</span>
                  </div>
                  <div v-else-if="item.debt < 0" class="debt-amount cr">
                    +{{ formatMoney(item.debt_abs) }} <span class="currency">UZS</span>
                  </div>
                  <span v-else class="text-muted small">—</span>
                </td>

                <td>
                  <div v-if="item.debt_dollar > 0" class="debt-amount">
                    {{ formatDollar(item.debt_dollar) }} <span class="currency">$</span>
                  </div>
                  <div v-else-if="item.debt_dollar < 0" class="debt-amount cr">
                    +{{ formatDollar(item.debt_dollar_abs) }} <span class="currency">$</span>
                  </div>
                  <span v-else class="text-muted small">—</span>
                </td>

                <td>
                  <div class="row-actions">
                    <button class="pay-btn" @click.stop="openPayModal(item)" title="To'lov qilish">
                      <b-icon icon="cash-stack"></b-icon>
                    </button>
                    <button class="hist-btn" @click.stop="openHistoryDirect(item)" title="To'lovlar tarixi">
                      <b-icon icon="clock-history"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="!loading && filteredDebtors.length === 0">
                <td colspan="8" class="empty-row">
                  <div class="py-5 text-center">
                    <p class="text-muted">{{ searchText ? 'Qidiruv natijasi topilmadi' : 'Nasiya yo\'q' }}</p>
                  </div>
                </td>
              </tr>

              <tr v-if="loading">
                <td colspan="8" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                </td>
              </tr>
            </tbody>

            <tfoot v-if="filteredDebtors.length > 0">
              <tr class="total-row">
                <td colspan="5" class="text-right font-bold">JAMI QARZ:</td>
                <td>
                  <div class="debt-amount font-bold">{{ formatMoney(totalDebt) }} <span class="currency">UZS</span></div>
                </td>
                <td>
                  <div v-if="totalDebtDollar !== 0" class="debt-amount font-bold">{{ formatDollar(totalDebtDollar) }} <span class="currency">$</span></div>
                  <span v-else class="text-muted small">—</span>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>

    <!-- SAVDOLAR RO'YXATI VA TARIX MODALI -->
    <div v-if="showSalesModal && selectedDebtor" class="modal-overlay" @click.self="closeSalesModal">
      <div class="sales-modal animate-pop">
        <div class="detail-header">
          <h3>{{ selectedDebtor.name }}</h3>
          <button class="close-btn" @click="closeSalesModal">&times;</button>
        </div>

        <div class="sales-info-bar">
          <span>
            Umumiy qarz:
            <b :class="selectedDebtor.debt < 0 ? 'green' : 'red'" v-if="selectedDebtor.debt">
              {{ selectedDebtor.debt < 0 ? '+' : '' }}{{ formatMoney(selectedDebtor.debt_abs) }} UZS
            </b>
            <b :class="selectedDebtor.debt_dollar < 0 ? 'green' : 'red'" v-if="selectedDebtor.debt_dollar" style="margin-left: 10px">
              {{ selectedDebtor.debt_dollar < 0 ? '+' : '' }}{{ formatDollar(selectedDebtor.debt_dollar_abs) }} $
            </b>
          </span>
          <span>Tel: <b>{{ selectedDebtor.phone_number || '-' }}</b></span>
          <button
            v-if="debtorSales.length > 1"
            class="btn btn-sm btn-warning ml-auto"
            @click="openBulkExtend"
          >
            🕒 Barchasiga muddat berish
          </button>
        </div>

        <!-- TAB BUTTONS -->
        <div class="tab-buttons">
          <button :class="['tab-btn', { active: activeTab === 'sales' }]" @click="activeTab = 'sales'">
            Qarzli savdolar
          </button>
          <button :class="['tab-btn', { active: activeTab === 'history' }]" @click="switchToHistory">
            To'lovlar tarixi
          </button>
        </div>

        <!-- SAVDOLAR TAB -->
        <div v-if="activeTab === 'sales'" class="sales-table-wrap">
          <table class="custom-table" v-if="debtorSales.length > 0">
            <thead>
              <tr>
                <th>№</th>
                <th>SANA</th>
                <th>JAMI</th>
                <th>TO'LANDI</th>
                <th>QARZ</th>
                <th>MUDDAT</th>
                <th style="width:160px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in debtorSales" :key="s.id">
                <td><span class="id-badge">{{ s.id }}</span></td>
                <td>{{ formatSaleDate(s.created_at) }}</td>
                <td class="price blue">{{ formatMoney(s.summa) }}</td>
                <td class="price green">{{ formatMoney(getSalePaid(s)) }}</td>
                <td><span :class="getSaleDebt(s) > 0 ? 'price red' : 'price green'">{{ formatMoney(getSaleDebt(s)) }}</span></td>
                <td>
                  <span v-if="s.debt_due_date" :class="saleDueTagClass(s)">
                    {{ formatPaymentDate(s.debt_due_date) }}
                  </span>
                  <span v-else class="text-muted small">Belgilanmagan</span>
                  <div v-if="s.debt_comment" class="small text-muted" style="max-width:160px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap" :title="s.debt_comment">
                    {{ s.debt_comment }}
                  </div>
                </td>
                <td class="text-center">
                  <button class="due-btn-sm" @click="openDueEdit(s)" :title="s.debt_due_date ? 'Muddat ozgartirish' : 'Muddat berish'">
                    🗓
                  </button>
                  <button v-if="getSaleDebt(s) > 0" class="pay-btn-sm ml-1" @click="openPayModalForSale(s)">
                    To'lash
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else-if="salesLoading" class="text-center py-5">
            <b-spinner variant="primary"></b-spinner>
          </div>
          <div v-else class="text-center py-5 text-muted">Qarzli savdo topilmadi</div>
        </div>

        <!-- TO'LOVLAR TARIXI TAB -->
        <div v-if="activeTab === 'history'" class="sales-table-wrap">
          <div class="hist-filter">
            <button :class="['hf-btn', historyFilter==='all'      ? 'active' : '']" @click="historyFilter='all'">Hammasi ({{ paymentHistory.length }})</button>
            <button :class="['hf-btn', historyFilter==='tolov'    ? 'active' : '']" @click="historyFilter='tolov'">💵 Faqat to'lovlar ({{ payHistoryCount('tolov') }})</button>
            <button :class="['hf-btn', historyFilter==='qarz'     ? 'active' : '']" @click="historyFilter='qarz'">📋 Qarzlar ({{ payHistoryCount('qarz') }})</button>
          </div>
          <table class="custom-table" v-if="filteredPaymentHistory.length > 0">
            <thead>
              <tr>
                <th>SANA</th>
                <th>HUJJAT TURI</th>
                <th>TO'LOV TURI</th>
                <th>TURI</th>
                <th>SUMMA</th>
                <th>IZOH</th>
                <th>AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="h in filteredPaymentHistory" :key="h.id" :class="h.type === 1 ? 'history-kirim' : 'history-chiqim'">
                <td>{{ formatSaleDate(h.datetime) }}</td>
                <td><span class="tag doc-tag">{{ h.doc_type }}</span></td>
                <td>{{ h.pay_type }}</td>
                <td>
                  <span :class="h.type === 1 ? 'tag green-tag' : 'tag red-tag'">
                    {{ h.type_name }}
                  </span>
                </td>
                <td :class="h.type === 1 ? 'price green' : 'price red'">
                  {{ h.type === 1 ? '+' : '-' }}{{ formatMoney(h.summa) }}
                </td>
                <td class="text-muted small">{{ h.comment }}</td>
                <td>
                  <button
                    v-if="canDeleteHistory(h)"
                    class="hist-del-btn"
                    :disabled="historyDeleting === h.id"
                    @click="deleteHistoryEntry(h)"
                    title="O'chirish"
                  >
                    <b-icon :icon="historyDeleting === h.id ? 'hourglass-split' : 'trash'"></b-icon>
                  </button>
                  <span v-else class="text-muted small" title="Savdo/kirim hujjatiga bog'liq — savdoni tahrirlang">🔒</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else-if="historyLoading" class="text-center py-5">
            <b-spinner variant="primary"></b-spinner>
          </div>
          <div v-else class="text-center py-5 text-muted">To'lovlar tarixi topilmadi</div>
        </div>
      </div>
    </div>

    <!-- MUDDAT TAHRIR / UZAYTIRISH MODALI -->
    <div v-if="dueModal.show" class="modal-overlay" @click.self="closeDueModal">
      <div class="due-modal animate-pop">
        <div class="detail-header">
          <h3>{{ dueModal.bulk ? 'Barcha qarzlarga muddat' : 'Muddat o\'zgartirish' }}</h3>
          <button class="close-btn" @click="closeDueModal">&times;</button>
        </div>

        <div class="due-body">
          <div v-if="!dueModal.bulk && dueModal.sale" class="due-context">
            <div><b>Savdo #{{ dueModal.sale.id }}</b></div>
            <div class="text-muted small">{{ formatSaleDate(dueModal.sale.created_at) }}</div>
            <div class="red small">Qarz: <b>{{ formatMoney(getSaleDebt(dueModal.sale)) }} UZS</b></div>
          </div>
          <div v-if="dueModal.bulk && selectedDebtor" class="due-context">
            <div><b>{{ selectedDebtor.name }}</b> — {{ debtorSales.length }} ta qarzli savdo</div>
            <div class="red small">Umumiy: <b>{{ formatMoney(selectedDebtor.debt_abs) }} UZS</b></div>
          </div>

          <label class="due-label">Yangi muddat</label>
          <div class="due-inputs">
            <input
              type="number" min="1" max="31" placeholder="Kun"
              v-model.number="dueModal.day"
              class="due-part"
            />
            <span>/</span>
            <input
              type="number" min="1" max="12" placeholder="Oy"
              v-model.number="dueModal.month"
              class="due-part"
            />
            <span>/</span>
            <span class="due-year">{{ dueModal.year }}</span>
          </div>

          <label class="due-label">Izoh (ixtiyoriy)</label>
          <input
            type="text"
            v-model="dueModal.comment"
            placeholder="Sababi, eslatma..."
            class="due-comment-input"
          />
        </div>

        <div class="due-foot">
          <button class="btn btn-light" @click="closeDueModal">Bekor</button>
          <button
            class="btn btn-primary"
            :disabled="dueModal.saving || !validDue"
            @click="saveDue"
          >
            {{ dueModal.saving ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>
    </div>

    <!-- TO'LOV MODALI -->
    <div v-if="showPayModal && payDebtor" class="modal-overlay" @click.self="closePayModal">
      <div class="pay-modal animate-pop">
        <div class="detail-header">
          <h3>Qarz to'lash — {{ payDebtor.name }}</h3>
          <button class="close-btn" @click="closePayModal">&times;</button>
        </div>

        <div class="pay-info">
          <div class="pay-info-row">
            <span class="info-label">Mijoz:</span>
            <span class="font-bold">{{ payDebtor.name }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">Umumiy qarz:</span>
            <span class="font-bold red">{{ formatMoney(payDebtor.debt_abs || Math.abs(payDebtor.debt || 0)) }} UZS</span>
          </div>
        </div>

        <div class="pay-form">
          <div class="pay-field">
            <label>TO'LOV TURI</label>
            <select v-model.number="selectedPayTypeId" class="pay-input">
              <option v-for="pt in payTypes" :key="pt.id" :value="pt.id">{{ pt.name }}</option>
            </select>
          </div>
          <div class="pay-field">
            <label>SUMMA</label>
            <input
              type="number"
              v-model.number="payAmount"
              min="0"
              class="pay-input"
              placeholder="0"
            />
          </div>
          <div class="pay-field">
            <label>Izoh</label>
            <input type="text" v-model="payForm.comment" class="pay-input" placeholder="Izoh..." />
          </div>
          <div class="pay-total-row">
            <span>Jami to'lov:</span>
            <span class="font-bold blue">{{ formatMoney(payAmount) }} UZS</span>
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closePayModal">BEKOR</button>
          <button class="m-btn pay-confirm" @click="submitPayment" :disabled="!canSubmitPay || payLoading">
            {{ payLoading ? 'Saqlanmoqda...' : 'TO\'LASH' }}
          </button>
        </div>

        <!-- To'lovlar tarixi (pay modal ichida) -->
        <div class="pay-history">
          <div class="pay-history-header" @click="payHistoryOpen = !payHistoryOpen">
            <span>
              <b-icon icon="clock-history"></b-icon>
              To'lovlar tarixi
              <span v-if="payHistoryItems.length" class="badge-count">{{ payHistoryItems.length }}</span>
            </span>
            <b-icon :icon="payHistoryOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
          </div>
          <div v-if="payHistoryOpen" class="pay-history-body">
            <div v-if="payHistoryLoading" class="text-center py-3">
              <b-spinner small variant="primary"></b-spinner>
            </div>
            <div v-else-if="payHistoryItems.length === 0" class="text-center py-3 text-muted small">
              Tarix yo'q
            </div>
            <table v-else class="history-mini-table">
              <thead>
                <tr>
                  <th>SANA</th>
                  <th>HUJJAT</th>
                  <th>TURI</th>
                  <th class="text-right">SUMMA</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="h in payHistoryItems.slice(0, 20)" :key="h.id">
                  <td>{{ formatSaleDate(h.datetime) }}</td>
                  <td class="small text-muted">{{ h.doc_type }}</td>
                  <td>
                    <span :class="h.type === 1 ? 'tag green-tag' : 'tag red-tag'">
                      {{ h.type === 1 ? 'Kirim' : 'Chiqim' }}
                    </span>
                    <span v-if="h.pay_type" class="text-muted small"> ({{ h.pay_type }})</span>
                  </td>
                  <td class="text-right" :class="h.type === 1 ? 'price green' : 'price red'">
                    {{ h.type === 1 ? '+' : '-' }}{{ formatMoney(h.summa) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';

export default {
  name: 'NasiyalarIndex',
  components: { Top },
  data() {
    return {
      loading: false,
      debtors: [],
      searchText: '',
      viewMode: 'debtor',   // 'debtor' = mijoz bizga qarz, 'creditor' = biz mijozga qarz, 'all' = hammasi
      filterStatus: 'all',
      // Eslatma kun oynasi — muddati o'tgan/yaqinlashayotganlarni shu kun bo'yicha aniqlaydi.
      // Default 3 kun; foydalanuvchi o'zgartirsa localStorage'da saqlanadi.
      alertDays: Number(localStorage.getItem('nasiya_alert_days')) || 3,
      showSalesModal: false,
      salesLoading: false,
      historyLoading: false,
      historyDeleting: null,   // o'chirilayotgan yozuv id'si
      historyFilter: 'all',    // 'all' | 'tolov' | 'qarz' — tarixni filtrlash
      selectedDebtor: null,
      debtorSales: [],
      paymentHistory: [],
      activeTab: 'sales',
      showPayModal: false,
      payLoading: false,
      payDebtor: null,
      payForm: { comment: '' },
      payTypes: [],
      selectedPayTypeId: 1,
      payAmount: 0,
      payHistoryItems: [],
      payHistoryLoading: false,
      payHistoryOpen: true,
      dueModal: {
        show: false,
        saving: false,
        bulk: false,
        sale: null,
        day: '',
        month: '',
        year: new Date().getFullYear(),
        comment: '',
      },
    };
  },
  computed: {
    // Kun oynasi (>=1). data.alertDays'dan, noto'g'ri qiymat bo'lsa 3.
    alertDaysNum() {
      const n = Number(this.alertDays);
      return n >= 1 ? Math.floor(n) : 3;
    },
    // Filtr tugmalari — "Yaqinlashayotgan" yorlig'i tanlangan kun sonini ko'rsatadi.
    filterOptions() {
      const n = this.alertDaysNum;
      return [
        { value: 'all',      label: 'Hammasi' },
        { value: 'alert',    label: 'Eslatma' },
        { value: 'overdue',  label: "Muddati o'tgan" },
        { value: 'upcoming', label: `Yaqinlashayotgan (${n} kun)` },
      ];
    },
    debtStatus() {
      // Har mijoz uchun muddat holatini aniqlash (mijozda `payment_date` bolsa)
      const now = Math.floor(Date.now() / 1000);
      const DAY = 24 * 60 * 60;
      const days = this.alertDaysNum;
      return (d) => {
        const pd = Number(d.payment_date || 0);
        if (!pd) return 'none';
        if (pd < now - days * DAY) return 'overdue_old';   // > N kun oldin otgan
        if (pd < now)               return 'overdue';      // <= N kun oldin otgan
        if (pd <= now + days * DAY) return 'upcoming';     // N kun ichida keladi
        return 'future';
      };
    },
    filteredByStatus() {
      const f = this.filterStatus;
      if (f === 'all') return this.debtors;
      const getSt = this.debtStatus;
      return this.debtors.filter((d) => {
        const st = getSt(d);
        if (f === 'overdue')  return st === 'overdue' || st === 'overdue_old';
        if (f === 'upcoming') return st === 'upcoming';
        if (f === 'alert')    return st === 'overdue' || st === 'upcoming';
        return true;
      });
    },
    filteredDebtors() {
      const base = this.filteredByStatus;
      if (!this.searchText) return base;
      const q = this.searchText.toLowerCase();
      return base.filter(d =>
        (d.name || '').toLowerCase().includes(q) ||
        (d.phone_number || '').includes(q)
      );
    },
    filterCounts() {
      const getSt = this.debtStatus;
      const counts = { all: this.debtors.length, alert: 0, overdue: 0, upcoming: 0 };
      for (const d of this.debtors) {
        const st = getSt(d);
        if (st === 'overdue' || st === 'overdue_old') counts.overdue++;
        if (st === 'upcoming') counts.upcoming++;
        if (st === 'overdue' || st === 'upcoming') counts.alert++;
      }
      return counts;
    },
    filteredPaymentHistory() {
      if (this.historyFilter === 'tolov') return this.paymentHistory.filter(h => h.doc_type === 'Тўлов');
      if (this.historyFilter === 'qarz')  return this.paymentHistory.filter(h => h.doc_type !== 'Тўлов');
      return this.paymentHistory;
    },
    totalDebt() {
      // SO'M qarzlarining absolyut yig'indisi (qarzdor + biz qarzmiz alohida ifoda etilmaydi)
      return this.filteredDebtors.reduce((s, d) => s + Math.abs(Number(d.debt || 0)), 0);
    },
    totalDebtDollar() {
      return this.filteredDebtors.reduce((s, d) => s + Math.abs(Number(d.debt_dollar || 0)), 0);
    },
    canSubmitPay() {
      return Number(this.payAmount) > 0 && !!this.selectedPayTypeId;
    },
    validDue() {
      const d = Number(this.dueModal.day);
      const m = Number(this.dueModal.month);
      return d >= 1 && d <= 31 && m >= 1 && m <= 12;
    },
  },
  watch: {
    // Kun o'zgarganda localStorage'ga saqlaymiz (keyingi safar eslab qoladi).
    alertDays(val) {
      const n = Number(val);
      if (n >= 1) localStorage.setItem('nasiya_alert_days', Math.floor(n));
    },
  },
  mounted() {
    this.fetchDebtors();
    this.fetchPayTypes();
  },
  methods: {
    async fetchDebtors() {
      this.loading = true;
      try {
        // viewMode: debtor → sign=plus (mijoz bizga qarz), creditor → sign=minus (biz qarzmiz), all → nonzero=1
        const params = this.viewMode === 'debtor'   ? { sign: 'plus' }
                     : this.viewMode === 'creditor' ? { sign: 'minus' }
                     : { nonzero: 1 };
        const res = await axios.get('api/v1/kontragent/debt-history', { params });
        const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
        // SO'M va DOLLAR qarzlarining ishorasini saqlaymiz (har bir ustun alohida ko'rsatadi)
        this.debtors = list.map(r => ({
          ...r,
          debt: Number(r.debt || 0),
          debt_abs: Math.abs(Number(r.debt || 0)),
          debt_dollar: Number(r.debt_dollar || 0),
          debt_dollar_abs: Math.abs(Number(r.debt_dollar || 0)),
        }));
      } catch (e) {
        console.error('Nasiyalarni yuklashda xato:', e);
        this.debtors = [];
      } finally {
        this.loading = false;
      }
    },
    setViewMode(mode) {
      this.viewMode = mode;
      this.fetchDebtors();
    },
    payHistoryCount(kind) {
      if (kind === 'tolov') return this.paymentHistory.filter(h => h.doc_type === 'Тўлов').length;
      if (kind === 'qarz')  return this.paymentHistory.filter(h => h.doc_type !== 'Тўлов').length;
      return this.paymentHistory.length;
    },
    formatMoney(v) {
      if (!v || v === 0) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/,/g, ' ');
    },
    formatDollar(v) {
      if (!v || v === 0) return '0';
      const n = Number(v);
      const fixed = Math.abs(n) >= 1 ? n.toFixed(2) : n.toFixed(4);
      return fixed.replace(/\.?0+$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    rowOnlyCreditor(item) {
      // Faqat "biz qarzmiz" — hech qaysi valyutada qarzdor emas, va kamida bittasida haqdor
      const som = Number(item.debt || 0);
      const dol = Number(item.debt_dollar || 0);
      return som <= 0 && dol <= 0 && (som < 0 || dol < 0);
    },
    formatPaymentDate(ts) {
      if (!ts) return '-';
      const date = new Date(Number(ts) * 1000);
      return date.toLocaleDateString('ru-RU');
    },
    formatSaleDate(ts) {
      if (!ts) return '-';
      const date = new Date(ts * 1000);
      return date.toLocaleDateString('ru-RU') + ' ' + date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    isOverdue(paymentDate) {
      if (!paymentDate) return false;
      const now = Math.floor(Date.now() / 1000);
      return Number(paymentDate) < now;
    },
    dueDateTagClass(item) {
      const st = this.debtStatus(item);
      if (st === 'overdue' || st === 'overdue_old') return 'tag red-tag';
      if (st === 'upcoming') return 'tag orange-tag';
      return 'tag green-tag';
    },
    saleDueTagClass(sale) {
      const now = Math.floor(Date.now() / 1000);
      const DAY = 24 * 60 * 60;
      const days = this.alertDaysNum;
      const pd = Number(sale.debt_due_date || 0);
      if (!pd) return 'tag';
      if (pd < now) return 'tag red-tag';
      if (pd <= now + days * DAY) return 'tag orange-tag';
      return 'tag green-tag';
    },
    openDueEdit(sale) {
      const pd = Number(sale.debt_due_date || 0);
      let day = '', month = '';
      if (pd > 0) {
        const d = new Date(pd * 1000);
        day = d.getDate();
        month = d.getMonth() + 1;
      }
      this.dueModal = {
        show: true,
        saving: false,
        bulk: false,
        sale,
        day,
        month,
        year: new Date().getFullYear(),
        comment: sale.debt_comment || '',
      };
    },
    openBulkExtend() {
      this.dueModal = {
        show: true,
        saving: false,
        bulk: true,
        sale: null,
        day: '',
        month: '',
        year: new Date().getFullYear(),
        comment: '',
      };
    },
    closeDueModal() {
      this.dueModal.show = false;
    },
    async saveDue() {
      if (!this.validDue) return;
      const d = Number(this.dueModal.day);
      const m = Number(this.dueModal.month);
      const y = this.dueModal.year;
      const ts = Math.floor(new Date(y, m - 1, d, 23, 59, 59).getTime() / 1000);
      const comment = this.dueModal.comment || null;

      this.dueModal.saving = true;
      try {
        if (this.dueModal.bulk) {
          await axios.post('api/v1/debt-reminder/bulk-extend', {
            kontragent_id: this.selectedDebtor.id,
            debt_due_date: ts,
            debt_comment: comment,
          });
          // mahalliy ro'yxatda yangilash
          for (const s of this.debtorSales) {
            s.debt_due_date = ts;
            if (comment !== null) s.debt_comment = comment;
          }
        } else {
          await axios.patch(`api/v1/debt-reminder/service_sale/${this.dueModal.sale.id}`, {
            debt_due_date: ts,
            debt_comment: comment,
          });
          this.dueModal.sale.debt_due_date = ts;
          if (comment !== null) this.dueModal.sale.debt_comment = comment;
        }
        this.closeDueModal();
        // mijozlar royxatini yangilash (payment_date o'zgargan bo'lishi mumkin)
        this.fetchDebtors();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.dueModal.saving = false;
      }
    },
    getSalePaid(s) {
      return Number(s.cash_summa || 0) + Number(s.plastic_summa || 0) + Number(s.shot_summa || 0);
    },
    getSaleDebt(s) {
      return Math.max(0, Number(s.summa || 0) - this.getSalePaid(s));
    },
    async openDebtorSales(debtor) {
      this.selectedDebtor = debtor;
      this.debtorSales = [];
      this.showSalesModal = true;
      this.salesLoading = true;
      try {
        const res = await axios.get('api/v1/service-sale', {
          params: { kontragent_id: debtor.id }
        });
        const sales = Array.isArray(res.data) ? res.data : [];
        this.debtorSales = sales.filter(s => this.getSaleDebt(s) > 0);
      } catch (e) {
        console.error('Savdolarni yuklashda xato:', e);
        this.debtorSales = [];
      } finally {
        this.salesLoading = false;
      }
    },
    closeSalesModal() {
      this.showSalesModal = false;
      this.selectedDebtor = null;
      this.debtorSales = [];
      this.paymentHistory = [];
      this.activeTab = 'sales';
    },
    async switchToHistory() {
      this.activeTab = 'history';
      if (this.paymentHistory.length > 0) return;
      this.historyLoading = true;
      try {
        const res = await axios.get(`api/v1/kontragent/payment-history/${this.selectedDebtor.id}`);
        this.paymentHistory = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error('Tarix yuklashda xato:', e);
        this.paymentHistory = [];
      } finally {
        this.historyLoading = false;
      }
    },
    // Barcha qarz/to'lov yozuvlarini o'chirish mumkin (savdoga bog'liq bo'lsa — faqat qarz qatori)
    canDeleteHistory(h) {
      return true;
    },
    isSaleLinked(h) {
      const SALE_LINKED = [
        'Хизмат кўрсатиш', 'Хизмат қайтариш', 'Чиқим', 'Кирим',
        'Возврат', 'Возврат поставщик', 'Ревизия', 'Перевод',
        'Списать', 'Ишлаб чиқариш', 'Конверсия',
      ];
      return SALE_LINKED.includes(h.doc_type);
    },
    async deleteHistoryEntry(h) {
      let msg;
      if (h.doc_type === 'Тўлов') {
        msg = "Bu to'lov o'chirilsinmi? Kassa va qarz yozuvlari qaytariladi.";
      } else if (this.isSaleLinked(h)) {
        msg = "⚠️ Bu yozuv savdoga bog'liq.\nFAQAT shu qarz qatori o'chadi (savdo, ombor, foyda o'zgarmaydi).\nEski/dublikat qarzni tozalash uchun ishlating.\n\nDavom etilsinmi?";
      } else {
        msg = "Bu qarz yozuvi o'chirilsinmi? Mijoz qarzi qayta hisoblanadi.";
      }
      if (!confirm(msg)) return;
      this.historyDeleting = h.id;
      try {
        await axios.delete(`api/v1/kontragent/register/${h.id}`);
        // Tarixni va mijozlar ro'yxatini yangilaymiz
        this.paymentHistory = this.paymentHistory.filter(x => x.id !== h.id);
        if (this.selectedDebtor && this.selectedDebtor.id) {
          try {
            const res = await axios.get(`api/v1/kontragent/payment-history/${this.selectedDebtor.id}`);
            this.paymentHistory = Array.isArray(res.data) ? res.data : [];
          } catch (e) { /* tarix bo'sh qoldi */ }
        }
        await this.fetchDebtors();
        // Modal sarlavhasidagi "Umumiy qarz"ni yangilaymiz
        if (this.selectedDebtor && this.selectedDebtor.id) {
          const fresh = this.debtors.find(d => d.id === this.selectedDebtor.id);
          if (fresh) this.selectedDebtor = { ...this.selectedDebtor, ...fresh };
        }
      } catch (e) {
        const status = e.response && e.response.status;
        const msg = e.response && e.response.data && e.response.data.message;
        if (status === 404) {
          alert("O'chirish endpointi serverda topilmadi (404). Backend yangilanishi (deploy) kerak.");
        } else if (status === 401) {
          alert("Ruxsat yo'q — bu amal faqat Admin uchun.");
        } else {
          alert((msg || "O'chirishda xatolik") + (status ? ` (kod: ${status})` : ''));
        }
      } finally {
        this.historyDeleting = null;
      }
    },
    async fetchPayTypes() {
      try {
        const res = await axios.get('api/v1/pay-type/');
        // Dollarni chiqaramiz (3) — nasiya to'lovida kerak emas
        this.payTypes = (res.data || []).filter(pt => Number(pt.id) !== 3)
          .sort((a, b) => a.id - b.id);
      } catch (e) {
        this.payTypes = [
          { id: 1, name: 'Naqd' },
          { id: 2, name: 'Plastik' },
          { id: 4, name: 'Perechileniya' },
        ];
      }
      if (!this.selectedPayTypeId && this.payTypes.length) {
        this.selectedPayTypeId = this.payTypes[0].id;
      }
    },
    resetPayForm() {
      this.payAmount = 0;
      if (this.payTypes.length) this.selectedPayTypeId = this.payTypes[0].id;
    },
    async loadPayHistory(kontragentId) {
      this.payHistoryLoading = true;
      this.payHistoryItems = [];
      try {
        const res = await axios.get(`api/v1/kontragent/payment-history/${kontragentId}`);
        this.payHistoryItems = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.payHistoryItems = [];
      } finally {
        this.payHistoryLoading = false;
      }
    },
    openPayModal(debtor) {
      this.payDebtor = { ...debtor, kontragent_id: debtor.id };
      this.payForm = { comment: `${debtor.name} qarz to'lovi` };
      const positiveDebt = Math.max(0, Number(debtor.debt) || 0);
      this.payAmount = positiveDebt;
      this.resetPayForm();
      this.payAmount = positiveDebt;
      this.showPayModal = true;
      this.loadPayHistory(debtor.id);
    },
    openPayModalForSale(sale) {
      const saleDebt = this.getSaleDebt(sale);
      this.payDebtor = { ...this.selectedDebtor, kontragent_id: this.selectedDebtor.id, debt: saleDebt, debt_abs: saleDebt };
      this.payForm = { comment: `Savdo #${sale.id} uchun to'lov` };
      this.resetPayForm();
      this.payAmount = saleDebt;
      this.showPayModal = true;
      this.loadPayHistory(this.selectedDebtor.id);
    },
    openHistoryDirect(debtor) {
      this.selectedDebtor = debtor;
      this.debtorSales = [];
      this.paymentHistory = [];
      this.showSalesModal = true;
      this.activeTab = 'history';
      this.switchToHistory();
      // Fonda qarzli savdolarni ham yuklab qo'yamiz
      this.openDebtorSalesBackground(debtor);
    },
    async openDebtorSalesBackground(debtor) {
      this.salesLoading = true;
      try {
        const res = await axios.get('api/v1/service-sale', { params: { kontragent_id: debtor.id } });
        const sales = Array.isArray(res.data) ? res.data : [];
        this.debtorSales = sales.filter(s => this.getSaleDebt(s) > 0);
      } catch (e) {
        this.debtorSales = [];
      } finally {
        this.salesLoading = false;
      }
    },
    closePayModal() {
      this.showPayModal = false;
      this.payDebtor = null;
    },
    async submitPayment() {
      const amount = Number(this.payAmount) || 0;
      if (amount <= 0 || !this.payDebtor) return;
      this.payLoading = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id'));
        const kontragent_id = this.payDebtor.kontragent_id || this.payDebtor.id;
        const numberRes = await axios.get('api/v1/kontragent-pay/last-number');
        const number = numberRes.data?.number || numberRes.data || 1;
        const datetime = Math.floor(Date.now() / 1000);

        // Bitta to'lov turi = bitta summa. pay_type_id ga qarab kassa bucketini tanlaymiz:
        //   1 (Naqd)    → cash_summa
        //   4 (Shot)    → shot_summa
        //   qolganlari  → plastic_summa
        const typeId = Number(this.selectedPayTypeId) || 1;
        let cash = 0, plastic = 0, shot = 0;
        if (typeId === 1)      cash = amount;
        else if (typeId === 4) shot = amount;
        else                   plastic = amount;

        await axios.post('api/v1/kontragent-pay', {
          datetime,
          sklad_id,
          kontragent_id,
          summa: amount,
          current_total: 0,
          current_total_dollar: 0,
          pay_type_id: typeId,
          type: true,
          number,
          dollar_rate: 1,
          pay_type_kassa: typeId,
          kassa_summa: 0,
          cash_summa: cash,
          plastic_summa: plastic,
          shot_summa: shot,
          dollar_summa: 0,
          qaytim_som: 0,
          qaytim_dollar: 0,
          comment: this.payForm.comment || '',
        });

        // Tarixni darhol yangilab, modalni yopamiz
        this.resetPayForm();
        this.loadPayHistory(this.payDebtor.kontragent_id);
        if (this.showSalesModal && this.selectedDebtor) {
          this.paymentHistory = [];
          this.openDebtorSalesBackground(this.selectedDebtor);
          this.switchToHistory();
        }
        this.fetchDebtors();
        this.closePayModal();
      } catch (e) {
        console.error('To\'lov xatosi:', e);
        alert("To'lovda xatolik yuz berdi");
      } finally {
        this.payLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #e11d48;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-tabs {
  display: flex;
  gap: 6px;
  background: #f1f5f9;
  padding: 4px;
  border-radius: 10px;
}

/* Eslatma kun oynasi */
.alert-days {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 3px 8px;
}
.alert-days .ad-label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
}
.alert-days .ad-step {
  width: 24px;
  height: 26px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  line-height: 1;
}
.alert-days .ad-step:hover { background: #5850ec; color: #fff; border-color: #5850ec; }
.alert-days .ad-input {
  width: 46px;
  height: 28px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  outline: none;
}
.alert-days .ad-input:focus { border-color: #5850ec; }
.alert-days .ad-suffix { font-size: 12px; color: #94a3b8; font-weight: 600; }
.hist-filter { display: flex; gap: 6px; margin-bottom: 10px; flex-wrap: wrap; }
.hf-btn { background: #f1f5f9; border: 1px solid #e2e8f0; color: #475569; padding: 6px 12px; border-radius: 7px; cursor: pointer; font-size: 12px; font-weight: 600; }
.hf-btn:hover { background: #e2e8f0; }
.hf-btn.active { background: #5850ec; color: #fff; border-color: #5850ec; }

.view-tabs { display: inline-flex; background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 3px; gap: 2px; margin-right: 8px; }
.vt-btn { background: transparent; border: none; padding: 7px 14px; border-radius: 8px; font-weight: 700; font-size: 13px; color: #64748b; cursor: pointer; }
.vt-btn:hover { background: #f1f5f9; }
.vt-btn.active.debtor   { background: #fff5f5; color: #c53030; }
.vt-btn.active.creditor { background: #f0fff4; color: #276749; }
.vt-btn.active          { background: #edf2f7; color: #2d3748; }

.total-badge.creditor { color: #276749; border-color: #c6f6d5; background: #f0fff4; }
.is-creditor { background: #f7fef9 !important; }
.cr-tag { background: #c6f6d5; color: #276749; padding: 2px 8px; border-radius: 6px; font-size: 10px; font-weight: 700; margin-left: 6px; }
.id-badge.cr { background: #c6f6d5; color: #276749; }
.debt-amount.cr { color: #276749 !important; }

.ft-btn {
  background: transparent;
  border: none;
  padding: 6px 12px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ft-btn:hover { background: rgba(255,255,255,0.6); }
.ft-btn.active { background: #5850ec; color: white; box-shadow: 0 2px 6px rgba(88,80,236,0.25); }
.ft-badge {
  background: #f97316;
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 9999px;
  min-width: 18px;
  text-align: center;
}
.ft-btn.active .ft-badge { background: white; color: #5850ec; }

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.search-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 12px 0 36px;
  font-size: 14px;
  outline: none;
  background: white;
  width: 220px;
}

.total-badge {
  background: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
}

.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 14px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 14px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.debt-row:hover td {
  background: #fff5f5;
}

.total-row td {
  padding: 14px 15px;
  background: #fff1f2;
  border-top: 2px solid #fecdd3;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

.phone-tag {
  color: #2563eb;
  font-weight: 600;
}

.tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.red-tag    { background: #fff1f2; color: #e11d48; }
.green-tag  { background: #ecfdf5; color: #10b981; }
.orange-tag { background: #fff7ed; color: #f97316; }

/* Muddat tugmasi (jadval qatorida) */
.due-btn-sm {
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #f97316;
  border-radius: 6px;
  width: 32px;
  height: 28px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.15s;
}
.due-btn-sm:hover { background: #fed7aa; }

/* Muddat modali */
.due-modal {
  background: white;
  border-radius: 16px;
  width: 420px;
  max-width: 95vw;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  overflow: hidden;
}
.due-body { padding: 20px; display: flex; flex-direction: column; gap: 12px; }
.due-context {
  background: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
}
.due-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
}
.due-inputs {
  display: flex; align-items: center; gap: 6px;
  font-size: 16px; font-weight: 700;
}
.due-part {
  width: 70px; height: 40px;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 15px; font-weight: 700;
  text-align: center; outline: none;
}
.due-part:focus { border-color: #5850ec; }
.due-year { padding: 0 10px; color: #64748b; }
.due-comment-input {
  height: 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
}
.due-comment-input:focus { border-color: #5850ec; }
.due-foot {
  padding: 14px 20px;
  border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px; justify-content: flex-end;
}

.debt-amount {
  color: #e11d48;
  font-weight: 800;
  font-size: 16px;
}

.currency {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
}

.text-muted { color: #94a3b8; }
.small      { font-size: 12px; }
.font-bold  { font-weight: 700; }
.text-dark  { color: #1e293b; }
.text-right { text-align: right; }
.text-center { text-align: center; }
.blue  { color: #2563eb; }
.green { color: #10b981; }
.red   { color: #e11d48; }
.price { font-weight: 700; }

.clickable-row { cursor: pointer; transition: background 0.15s; }
.clickable-row:hover { background: #fff5f5; }

.pay-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.row-actions {
  display: flex;
  gap: 6px;
  justify-content: center;
}
.hist-btn {
  background: #eff6ff;
  color: #2563eb;
  border: none;
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  transition: .15s;
}
.hist-btn:hover { background: #2563eb; color: white; }
.hist-del-btn {
  background: #fff1f2;
  color: #e11d48;
  border: none;
  padding: 5px 9px;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
  transition: .15s;
}
.hist-del-btn:hover { background: #e11d48; color: white; }
.hist-del-btn:disabled { opacity: .5; cursor: not-allowed; }

.pay-history {
  margin-top: 16px;
  background: #f8fafc;
  border-radius: 12px;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
}
.pay-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  color: #475569;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}
.pay-history-header:hover { color: #2563eb; }
.badge-count {
  background: #2563eb;
  color: white;
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 11px;
  margin-left: 6px;
}
.pay-history-body {
  margin-top: 8px;
  max-height: 260px;
  overflow-y: auto;
}
.history-mini-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.history-mini-table th {
  text-align: left;
  padding: 6px 8px;
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: .5px;
  border-bottom: 1px solid #e2e8f0;
  background: #f1f5f9;
  position: sticky;
  top: 0;
}
.history-mini-table td {
  padding: 6px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}
.history-mini-table .text-right { text-align: right; }

.pay-btn-sm {
  background: #fef3c7;
  color: #d97706;
  border: none;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 11px;
  cursor: pointer;
}

/* MODAL OVERLAY */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15,23,42,0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.animate-pop {
  animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes pop {
  0%   { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1);   opacity: 1; }
}

/* SALES MODAL */
.sales-modal {
  background: white;
  border-radius: 24px;
  width: 700px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #f1f5f9;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}

.close-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  font-size: 22px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover { background: #e2e8f0; }

.sales-info-bar {
  display: flex;
  justify-content: space-between;
  padding: 12px 25px;
  background: #fff1f2;
  font-size: 14px;
}

.tab-buttons {
  display: flex;
  padding: 0 25px;
  gap: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background: none;
  font-weight: 700;
  font-size: 13px;
  color: #94a3b8;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab-btn.active {
  color: #e11d48;
  border-bottom-color: #e11d48;
}

.tab-btn:hover {
  color: #475569;
}

.doc-tag {
  background: #eff6ff;
  color: #2563eb;
}

.history-kirim td { background: #f0fdf4; }
.history-chiqim td { background: #fff5f5; }

.sales-table-wrap {
  padding: 10px;
  max-height: 400px;
  overflow-y: auto;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

/* PAY MODAL */
.pay-modal {
  background: white;
  border-radius: 24px;
  width: 480px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.pay-info {
  padding: 16px 25px;
  background: #f8fafc;
}

.pay-info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
}

.info-label {
  color: #94a3b8;
  margin-right: 4px;
}

.pay-form {
  padding: 20px 25px;
}

.pay-field {
  margin-bottom: 12px;
}

.pay-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.pay-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  outline: none;
}

.pay-input:focus {
  border-color: #e11d48;
  box-shadow: 0 0 0 3px rgba(225,29,72,0.1);
}

.pay-total-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0 0;
  margin-top: 8px;
  border-top: 2px solid #e2e8f0;
  font-size: 16px;
}

.pay-actions {
  display: flex;
  gap: 12px;
  padding: 0 25px 20px;
}

.m-btn {
  flex: 1;
  padding: 13px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel  { background: #f1f5f9; color: #64748b; }

.pay-confirm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.pay-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
